"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useRSVPs = exports.useGroup = exports.prettifyGroup = exports.findActiveGroupSession = exports.GroupUtil = void 0;
var _react = require("react");
var _lodash = require("lodash");
var _momentTimezone = _interopRequireDefault(require("moment-timezone"));
var _ = require("./");
var _shared = require("../shared");
var _session = require("./session.util");
var _types = require("../types");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) { ; } } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
// Composes a sentence about recurring session times. E.g.
// Monday 5pm + Friday 10am => Monday at 5pm and Friday at 10am
// Tuesday 8pm + Thursday 8pm => Tuesday and Thursday at 8pm
var renderRecurringTimesText = function renderRecurringTimesText() {
  var sessions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var upcomingSessions = sessions.filter(function (session) {
    return (0, _session.sessionIsUpcoming)(session) || (0, _session.sessionIsTodayAndNotEnded)(session);
  });
  var sessionTimes = (0, _lodash.chain)(upcomingSessions).map(function (session) {
    // Need to use tz object in order to use "z" token in formatting
    var startsAt = (0, _momentTimezone.default)(session.startAt);
    return {
      index: startsAt.day(),
      weekday: startsAt.format('dddd'),
      time: startsAt.format('h:mma'),
      // Store zone separate from time because if upcoming sessions span across daylight savings
      // it would cause duplicate dates (e.g. "Wednesday 4pm EST" and "Wednesday 4pm EDT")
      zone: startsAt.format('z')
    };
  }).uniqBy(function (_ref) {
    var weekday = _ref.weekday,
      time = _ref.time;
    return "".concat(weekday, " ").concat(time);
  }).sortBy('index').groupBy('time').map(function (dates, time) {
    var dateString = '';
    dates.forEach(function (date, key) {
      if (dates.length < 3) {
        switch (key) {
          case 0:
            dateString += "".concat(date.weekday, "s");
            break;
          default:
            dateString += " and ".concat(date.weekday, "s");
        }
      } else {
        switch (key) {
          case 0:
            dateString += "".concat(date.weekday, "s,");
            break;
          case dates.length - 1:
            dateString += " and ".concat(date.weekday, "s");
            break;
          case dates.length - 2:
            dateString += " ".concat(date.weekday, "s ");
            break;
          default:
            dateString += " ".concat(date.weekday, "s,");
        }
      }
    });
    // The timezone can differ between dates if they span across DST, so just grab the first one
    var zone = (0, _lodash.get)(dates, '[0].zone');
    return "".concat(dateString, " at ").concat(time, " ").concat(zone);
  }).join(', ').value();
  return "".concat(sessionTimes);
};
var useUpdateFavorite = function useUpdateFavorite(_ref2) {
  var handleSuccess = _ref2.handleSuccess;
  return (0, _.useUpdate)({
    update: (0, _react.useCallback)( /*#__PURE__*/function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(_ref3) {
        var groupId, isFavorite, groupName;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                groupId = _ref3.groupId, isFavorite = _ref3.isFavorite, groupName = _ref3.groupName;
                if (!isFavorite) {
                  _context.next = 7;
                  break;
                }
                _context.next = 4;
                return _.api.post((0, _.getGroupFavoriteUrl)(groupId), {});
              case 4:
                (0, _shared.trackUserEvent)({
                  eventName: 'Group Favorite',
                  eventValues: {
                    groupId: groupId,
                    groupName: groupName
                  }
                });
                _context.next = 10;
                break;
              case 7:
                _context.next = 9;
                return _.api.delete((0, _.getGroupFavoriteUrl)(groupId));
              case 9:
                (0, _shared.trackUserEvent)({
                  eventName: 'Remove Group Favorite',
                  eventValues: {
                    groupId: groupId,
                    groupName: groupName
                  }
                });
              case 10:
                return _context.abrupt("return", handleSuccess(isFavorite));
              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      return function (_x) {
        return _ref4.apply(this, arguments);
      };
    }(), [handleSuccess])
  });
};
var makeShareModalDescription = function makeShareModalDescription(groupName) {
  return "Check out this free therapist-moderated support group, ".concat(groupName, ". It\u2019s virtual, and you can join anonymously or not. Hope you\u2019ll join me!");
};
var makeShareModalTitle = function makeShareModalTitle(groupName) {
  return "Free therapist-moderated support group: ".concat(groupName);
};
var getDetailURL = function getDetailURL(slug, id) {
  var identifier = slug ? slug[0] : id;
  return "/groups/".concat(identifier);
};
var getUpcomingGroupsSortedByNearestSession = function getUpcomingGroupsSortedByNearestSession(groups) {
  var groupsWithSortedSessions = groups.map(function (group) {
    return _objectSpread(_objectSpread({}, group), {}, {
      groupSessions: (0, _lodash.orderBy)(group.groupSessions.filter(function (session) {
        return (0, _session.sessionIsUpcoming)(session);
      }), ['startsAt'], ['asc'])
    });
  }).filter(function (_ref5) {
    var groupSessions = _ref5.groupSessions;
    return !(0, _lodash.isEmpty)(groupSessions);
  });
  return (0, _lodash.orderBy)(groupsWithSortedSessions, ['groupSessions[0].startAt'], ['asc']);
};
var rejectArchivedGroups = function rejectArchivedGroups(groups) {
  return (0, _lodash.reject)(groups, function (_ref6) {
    var status = _ref6.status,
      groupSessions = _ref6.groupSessions;
    return status === _types.GroupStatus.Archived || (0, _lodash.every)(groupSessions, function (session) {
      return session.archived;
    });
  });
};
var getNoAvailableSessionErrorMessage = function getNoAvailableSessionErrorMessage(bufferMinutes) {
  return "The group session you\u2019re attempting to join is currently not accessible. It\u2019s important to note that sessions can only be joined within a grace period of ".concat(bufferMinutes, " minutes before the start time or ").concat(bufferMinutes, " minutes after the end time. Please ensure you\u2019re within this time frame and try again.");
};
var findActiveGroupSession = function findActiveGroupSession(sessions) {
  return sessions ? sessions.find(function (session) {
    return (0, _.isCallJoinable)({
      startsAt: session.startAt,
      endsAt: session.endAt,
      bufferBefore: _.GROUP_CALL_MEMBER_JOIN_GRACE_PERIOD,
      bufferAfter: _.GROUP_CALL_MEMBER_JOIN_GRACE_PERIOD
    }) && !session.archived;
  }) : null;
};
exports.findActiveGroupSession = findActiveGroupSession;
var sessionNotArchived = function sessionNotArchived(_ref7) {
  var archived = _ref7.archived;
  return !archived;
};
var prettifyGroup = function prettifyGroup(group) {
  return _objectSpread(_objectSpread({}, group), {}, {
    groupSessions: (0, _lodash.chain)(group.groupSessions).filter(sessionNotArchived).sortBy('startAt').slice(0, 4).value()
  });
};
exports.prettifyGroup = prettifyGroup;
var useGroup = function useGroup(groupId) {
  var _groupData$groupSessi;
  var _useFetch = (0, _.useFetch)((0, _.getGroupUrl)(groupId)),
    isLoadingGroupDataRaw = _useFetch.loading,
    groupDataRaw = _useFetch.data;
  var _useState = (0, _react.useState)(null),
    _useState2 = _slicedToArray(_useState, 2),
    groupData = _useState2[0],
    setGroupData = _useState2[1];
  (0, _react.useEffect)(function () {
    if (groupDataRaw) {
      setGroupData(prettifyGroup(groupDataRaw));
    }
  }, [groupDataRaw]);
  var hasUpcomingGroupSessions = (groupData === null || groupData === void 0 ? void 0 : (_groupData$groupSessi = groupData.groupSessions) === null || _groupData$groupSessi === void 0 ? void 0 : _groupData$groupSessi.length) > 0;
  return {
    groupData: groupData,
    setGroupData: setGroupData,
    isFetchingGroup: isLoadingGroupDataRaw || !groupData,
    hasUpcomingGroupSessions: hasUpcomingGroupSessions
  };
};
exports.useGroup = useGroup;
var useRSVPs = function useRSVPs() {
  var _useFetch2 = (0, _.useFetch)((0, _.getGroupSessionRsvpsByPatientUrl)(), []),
    isFetchingRSVPs = _useFetch2.loading,
    rsvps = _useFetch2.data,
    refetchRsvps = _useFetch2.refetch;
  var rsvpsByGroup = (0, _react.useMemo)(function () {
    return (0, _lodash.groupBy)((0, _lodash.filter)(rsvps, function (rsvp) {
      var _rsvp$groupSession;
      return !((_rsvp$groupSession = rsvp.groupSession) !== null && _rsvp$groupSession !== void 0 && _rsvp$groupSession.archived);
    }), 'groupSession.groupId');
  }, [rsvps]);
  return {
    isFetchingRSVPs: isFetchingRSVPs,
    refetchRsvps: refetchRsvps,
    rsvpsByGroup: rsvpsByGroup
  };
};
exports.useRSVPs = useRSVPs;
var GroupUtil = {
  renderRecurringTimesText: renderRecurringTimesText,
  useUpdateFavorite: useUpdateFavorite,
  makeShareModalDescription: makeShareModalDescription,
  makeShareModalTitle: makeShareModalTitle,
  getDetailURL: getDetailURL,
  getUpcomingGroupsSortedByNearestSession: getUpcomingGroupsSortedByNearestSession,
  rejectArchivedGroups: rejectArchivedGroups,
  getNoAvailableSessionErrorMessage: getNoAvailableSessionErrorMessage
};
exports.GroupUtil = GroupUtil;